import { memo, useEffect, useMemo, useState } from "react";
import PeoplesTile from "../Sub_components/PeoplesTile";
import { useLiveStreamAppContext } from "../ContextStore/Store";
import DataChanneling from "../GeneralFunctions/DataChanneling";

function AttendeeList({ onClose, onDropdownToggle }) {
  const {
    ArrRemoteParticipants,
    role,
    call,
    setAttendees,
    attendeeList,
    isInstructorMode,
    setToggleStates,
    toggleStates,
  } = useLiveStreamAppContext();

  const { sendActionToAttendee } = DataChanneling();
  const [searchAttendeeList, setSearchAttendeeList] = useState("");
  const [filteredAttendeesInClass, setFilteredAttendeesInClass] = useState([]);
  const [filteredAttendeesNotClass, setFilteredAttendeesNotClass] = useState([]);

  const computedInMeeting = useMemo(() => {
    return attendeeList
      .filter((e) =>
        ArrRemoteParticipants.some((participant) => participant.identifier.communicationUserId === e.communicationUserId))
      .map((attendee) => {
        const matchingParticipant = ArrRemoteParticipants.find(
          (participant) =>
            participant.identifier.communicationUserId === attendee.communicationUserId
        );
        return {
          ...attendee,
          displayName: matchingParticipant?.displayName || "Unknown",
        };
      })
      .sort((a, b) => a.displayName.localeCompare(b.displayName));
  }, [attendeeList, ArrRemoteParticipants]);

  const computedNotInMeeting = useMemo(() => {
    return attendeeList
      .filter((e) =>
        !ArrRemoteParticipants.map((participant) => participant.identifier.communicationUserId).includes(e.communicationUserId))
      .sort((a, b) => a.firstName.localeCompare(b.firstName));
  }, [attendeeList, ArrRemoteParticipants]);

  useEffect(() => {
    const inClass = computedInMeeting.filter((attendee) => {
      const fullName = `${attendee.displayName}`.toLowerCase();
      const searchTerms = searchAttendeeList.toLowerCase().split(" ").filter(Boolean);
      return searchTerms.every((term) => fullName.includes(term));
    });

    const notClass = computedNotInMeeting.filter((attendee) => {
      const fullName = `${attendee.firstName} ${attendee.lastName}`.toLowerCase();
      const searchTerms = searchAttendeeList.toLowerCase().split(" ").filter(Boolean);
      return searchTerms.every((term) => fullName.includes(term));
    });

    setFilteredAttendeesInClass(inClass)
    setFilteredAttendeesNotClass(notClass)
  }, [computedInMeeting, computedNotInMeeting, searchAttendeeList])

  const handleMicAllButton = (data) => {
    setAttendees((prevAttendees) =>
      prevAttendees.map((attendee) => {
        return { ...attendee, isMute: data };
      })
    );
    setToggleStates((prevStates) => ({
      ...prevStates,
      EnableMic: !data,
    }));
  };

  const toggleMic = () => {
    if (toggleStates["EnableMic"]) {
      sendActionToAttendee("ALL", "DISABLE_MIC_FOR_ALL");
      handleMicAllButton(true);
    } else {
      sendActionToAttendee("ALL", "ENABLE_MIC_FOR_ALL");
      handleMicAllButton(false);
    }
  };

  return (
    <>
      <div className="panel-title-for-mob">
        <div className="backIcon" onClick={onClose}>
          <i className="icon font-awesome-normal-pro va-back-arrow"></i>
        </div>
        <div className="back-page-title">
          <span>Attendees</span>
        </div>
      </div>
      <div className="attendees-list section-rightside-inner">
        <div className="section-title">Attendees</div>
        {role === "Presenter" && (
          <div className="search-box-live-stream">
            <input
              className="search-input custom-input-live-stream"
              type="text"
              value={searchAttendeeList}
              onChange={(e) => setSearchAttendeeList(e.target.value)}
              placeholder="Search Attendee"
              style={{ width: "100%" }}
            />
          </div>
        )}
        <div className="all-attendee">
          <div className="class-in-action">
            <div className="section-small-title">In Class</div>
            {role === "Presenter" && (
              <div>
                <a
                  href
                  className={`brd-btn-small ${
                    isInstructorMode && "divDisabled btn-height"
                  }  `}
                  onClick={toggleMic}
                >
                  {!toggleStates["EnableMic"]
                    ? "Enable Microphone"
                    : "Disable Microphone"}
                </a>
                {isInstructorMode && (
                  <span className="tooltip-new enableMicrophoneTooltip">
                    <span className="Instructor-Tool-icon">
                      <i className="fal fa-info-circle mob-tooltip">
                        <span id="InstructorToolTip" className="tooltiptext">
                          This cannot be changed when Instructor Only Mode is
                          on.
                        </span>
                      </i>
                    </span>
                  </span>
                )}
              </div>
            )}
          </div>
        </div>
        <div className="all-attendee-scroll custom-scroll">
          <div className="section-attendee-list class-in">
            <div className="class-in-list">
              {filteredAttendeesInClass.length === 0
                ? "No attendee found."
                : filteredAttendeesInClass.map((item, index) => {
                return (
                  <PeoplesTile
                    key={index}
                    inClass={true}
                    peopleName={item.displayName}
                    people={item.communicationUserId}
                    ArrRemoteParticipants={ArrRemoteParticipants}
                    call={call}
                    photoUrl={item.photo}
                    fullObject={item}
                    onDropdownToggle={onDropdownToggle}
                  />
                );
              })}
            </div>
          </div>
          {role === "Presenter" &&
            filteredAttendeesNotClass &&
            filteredAttendeesNotClass.length > 0 && (
            <div className="section-attendee-list class-in-not">
              <div className="class-in-action">
                  <div className="section-small-disable-title">
                    Not In Class
                  </div>
              </div>
              <div className="class-in-list">
                  {filteredAttendeesNotClass.length === 0
                    ? "No attendee found."
                    : filteredAttendeesNotClass.map((item, index) => {
                  return (
                    <PeoplesTile
                      key={index}
                      inClass={false}
                      peopleName={item.firstName + " " + item.lastName}
                      people={item.communicationUserId}
                      ArrRemoteParticipants={ArrRemoteParticipants}
                      remoteParticipants={ArrRemoteParticipants}
                      call={call}
                      photoUrl={item.photo}
                      fullObject={item}
                      onDropdownToggle={onDropdownToggle}
                    />
                  );
                })}
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
}
export default memo(AttendeeList);
